define('lq/events/actions/downloadExternalDocumentCommand',[
    'underscore',
    'lq/events/actions/eventAction',
    'lq'
], function (_, EventAction, lq) {
    'use strict';

    function DownloadExternalDocumentCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;

        return this;
    }

    EventAction.extend(DownloadExternalDocumentCommand, EventAction);

    DownloadExternalDocumentCommand.typeName = 'DownloadExternalDocumentCommand';

    DownloadExternalDocumentCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    DownloadExternalDocumentCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "DownloadExternalDocument",
            command: this.eventData.command
        };
    };

    DownloadExternalDocumentCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.directDownloadEnabled &&
            eventActionResponse.url &&
            eventActionResponse.fileName) {
            window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), {
                url: eventActionResponse.url,
                filename: eventActionResponse.fileName,
                openInBrowser: false
            });
        } else if (eventActionResponse.directDownloadEnabled &&
            (!eventActionResponse.url || !eventActionResponse.fileName)) {
            window.location = this.piping.url.prepare(lq.getTenantUrl('DownloadExternalDocument/Download'), {
                    actionId: this.piping.actionId,
                    commandId: this.eventData.command,
                    parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters())
                });
        }
        continuation();
    };

    return DownloadExternalDocumentCommand;
});

